import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'ramda/src/isEmpty';
import classNames from 'classnames';
import Icon from '@components/@core/Icon';
import EditDropdown from '@components/EditDropdown';
import HDropdown from '@components/HoverDropdown';
import { CertificationReportMenu } from '~/services/config';

const CertReport = ({ role, data, onClick }) => {
    return (
        <div className="certifications-report-list">
            <div className="d-flex border-bottom py-3 desktop-screen">
                <div className="d-flex-7 dsl-m12 text-400">Certifications</div>
                <div className="d-flex-1 dsl-m12 ms-2 ms-md-1 text-400 text-end">Open</div>
                <div className="d-flex-8 dsl-m12 ms-1 px-3 text-400">Employees</div>
                <div className="d-flex-2 dsl-m12 ms-md-1 text-400">Completed</div>
                <div className="d-flex-8 dsl-m12 px-md-3 text-400">Employees</div>
                <div className="d-flex-1 desktop-screen" />
            </div>
            {isEmpty(data) ? (
                <div className="d-h-center pt-4">
                    <span className="dsl-m16">No certifications Assigned</span>
                </div>
            ) : (
                data?.map((program) => {
                    const openEmployees = program?.stats?.open_employees?.map((e) => {
                        const { id, profile, program } = e;
                        return {
                            id,
                            value: `${profile.first_name} ${profile.last_name}`,
                            program,
                        };
                    });
                    const completedEmployees = program?.stats?.completed_employees?.map((e) => {
                        const { id, profile, program } = e;
                        return {
                            id,
                            value: `${profile.first_name} ${profile.last_name}`,
                            program,
                        };
                    });
                    let editOptions = CertificationReportMenu[role].filter((option) => option !== 'Edit Certification' && option !== 'Save Actuals');
                    return (
                        <div className="cert-list d-flex ssm-column ai-center ssm-ai-start border-bottom py-0 py-md-4" key={program.id}>
                            <div className="d-flex ai-center jc-between d-flex-7 cursor-pointer py-2 w-100" onClick={() => onClick('view certification', program, null, 'certifications')}>
                                <div className="d-flex ai-center">
                                    <Icon name="fas fa-certificate" size={22} />
                                    <span className="dsl-b14 ms-3 text-400 text-break">{program?.title}</span>
                                </div>
                                <EditDropdown className="mobile-screen" options={editOptions} onChange={(e) => onClick(e, program, null, 'certifications')} />
                            </div>
                            <div className="d-flex-1 dsl-b14 text-end ssm-left text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Open</label>
                                {program?.stats?.open}
                            </div>
                            <div className="d-flex d-flex-8 dsl-b14 px-0 px-md-3 text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Employee</label>
                                <HDropdown className="p-0" placeholder="No employee" data={openEmployees} onClick={(data) => onClick('view certification', data, null, 'employees')} />
                            </div>
                            <div className="d-flex-2 dsl-b14 text-end ssm-left text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Completed</label>
                                {program?.stats?.completed}
                            </div>
                            <div className="d-flex d-flex-8 dsl-b14 px-md-3 text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Employees</label>
                                <HDropdown className="p-0" placeholder="No employee" data={completedEmployees} onClick={(data) => onClick('view certification', data, null, 'employees')} />
                            </div>
                            <div className="d-flex-1 desktop-screen">
                                <EditDropdown options={editOptions} onChange={(e) => onClick(e, program, null, 'certifications')} />
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    );
};

CertReport.propTypes = {
    admin: PropTypes.bool,
    data: PropTypes.array,
    onClick: PropTypes.func,
};

CertReport.defaultProps = {
    admin: false,
    data: [],
    onClick: () => {},
};

export default CertReport;
